module.exports = __webpack_public_path__ + "static/img/areaA-26.7cfc953.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-26.png
// module id = 938
// module chunks = 1